import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Service } from "../service.class";
import { IModality } from "../../../shared/entities/modality.model";

@Injectable({
	providedIn: "root",
})
export class ModalitiesService {
	private server_path: string = "/v2/data/modalities";

	constructor(private service: Service) {}

	public getModalities(): Observable<{ data: IModality[] }> {
		return this.service.apiGetWithoutParams(this.server_path);
	}
}
